// extracted by mini-css-extract-plugin
export default {"toast":"vp_Bkjf9","content":"vp_TfsaN","symbol":"vp_ciECQ","icon":"vp_wrOis","details":"vp_MB_XB","message":"vp_Oz1RN","description":"vp_rnyJ1"};